import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

import { ApolloProvider } from "@apollo/client/react";
import { DemoProvider } from "./shared/store/contexts";

import { client } from "./shared/store/contexts/context.apollo.utils";
import App from "./App";

// Import styles
import "./assets/styles/index.css";
import "./App.css";

//Create root
const container = document.getElementById("root");
const root = createRoot(container);

// // Render app
root.render(
  <DemoProvider>
    <Router>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </Router>
  </DemoProvider>,
);
